var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSearch = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5005 2.25C8.3123 2.25 6.21377 3.11924 4.6665 4.6665C3.11924 6.21377 2.25 8.3123 2.25 10.5005C2.25 12.6886 3.11924 14.7872 4.6665 16.3344C6.21377 17.8817 8.3123 18.7509 10.5005 18.7509C12.4372 18.7509 14.3037 18.07 15.7799 16.8406L20.4697 21.5303C20.7626 21.8232 21.2374 21.8232 21.5303 21.5303C21.8232 21.2374 21.8232 20.7626 21.5303 20.4697L16.8406 15.78C18.07 14.3037 18.7509 12.4372 18.7509 10.5005C18.7509 8.3123 17.8817 6.21377 16.3344 4.6665C14.7872 3.11924 12.6886 2.25 10.5005 2.25ZM15.2969 15.2505C16.5484 13.9868 17.2509 12.2799 17.2509 10.5005C17.2509 8.71013 16.5397 6.99312 15.2738 5.72717C14.0078 4.46121 12.2908 3.75 10.5005 3.75C8.71013 3.75 6.99312 4.46121 5.72717 5.72717C4.46121 6.99312 3.75 8.71013 3.75 10.5005C3.75 12.2908 4.46121 14.0078 5.72717 15.2738C6.99312 16.5397 8.71013 17.2509 10.5005 17.2509C12.2799 17.2509 13.9868 16.5484 15.2505 15.2969C15.2579 15.2889 15.2654 15.281 15.2732 15.2732C15.281 15.2654 15.2889 15.2579 15.2969 15.2505Z",
    fill: "#171719"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Search.a8a3fda1.svg";
export { ForwardRef as ReactComponent };